let moduleName = 'Utilities';


class UtilitiesFactory {

    constructor() {}

    getUtilities () {
        return {
            forms: {
                setControlsToDirty(form) {
                    angular.forEach(form, value => {
                        if (angular.isObject(value) && value.hasOwnProperty('$modelValue')) {
                            value.$setDirty();
                        }
                    });
                }
            },
            strings: {
                isPdf(name) {
                    return _.endsWith(name, '.pdf');
                }
            }
        };
    }

    /***
     * Pagination Range
     * @param currentPage
     * @param offset
     * @param pagesTotal
     * @returns {Array}
     */
    paginationRange (currentPage, offset, pagesTotal) {
        let start;
        let end;

        currentPage = parseInt(currentPage);

        if (pagesTotal <= 2 * offset + 1) {
            start = 1;
            end = pagesTotal;
        } else if (currentPage - offset <= 0) {
            start = 1;
            end = 2 * offset + 2;
        } else if (currentPage + offset > pagesTotal) {
            start = pagesTotal - 2 * offset;
            end = pagesTotal;
        } else {
            start = currentPage - offset;
            end = currentPage + offset;
        }

        return _.range(start, end + 1);
    };


    /***
     * Decode Html Entity
     * @param str
     */
    decodeHtmlEntity (str) {
        return str.replace(/&#(\d+);/g, function(match, dec) {
            return String.fromCharCode(dec);
        });
    };

    static utilitiesFactory(){
        return new UtilitiesFactory();
    }
}


UtilitiesFactory.utilitiesFactory.$inject = [];

angular.module(moduleName, [])
    .factory('UtilitiesFactory', UtilitiesFactory.utilitiesFactory);


export default moduleName;



// WEBPACK FOOTER //
// ./src/app/services/utilities.js